import { TextLabel } from '../TextLabel';
import { IMessage } from './AppMessageMessage.model';
import {
	StyledContainer,
	StyledImage,
	StyledNameContainer,
	StyledMessageContainer,
	StyledTextContainer,
} from './AppMessageMessage.styled';

const AppMessageMessage = ({ type, player, time, text, online }: IMessage) => {
	return (
		<StyledContainer $type={type}>
			<StyledImage $online={online} />
			<StyledMessageContainer $type={type}>
				<StyledNameContainer $type={type} $online={online}>
					<TextLabel className={'name'}>{player}</TextLabel>
					<TextLabel className={'time'}>{time}</TextLabel>
				</StyledNameContainer>
				<StyledTextContainer $type={type}>
					<TextLabel>{text}</TextLabel>
				</StyledTextContainer>
			</StyledMessageContainer>
		</StyledContainer>
	);
};

export { AppMessageMessage, StyledImage };
